<template>
    <div class="col-md-12">
        <EmailContactsTable ref="contactsTable" @changed="$refs.groupsTable.refresh()"></EmailContactsTable>
        <EmailGroupsTable   ref="groupsTable"   @changed="$refs.contactsTable.refresh()"></EmailGroupsTable>
    </div>
</template>

<script>
import EmailContactsTable from './contacts/EmailContactsTable.vue';
import EmailGroupsTable from './contacts/EmailGroupsTable.vue';

export default {
    name: "ConfigEmailContacts",
    components: {
        EmailContactsTable,
        EmailGroupsTable,
    },
    data() {
        return {}
    },
    created() {},
    methods: {
    }
}
</script>